import React, { Fragment, useCallback, useContext, useEffect, useState } from 'react';
import { Button, Image, InputNumber, NavTabs } from 'app/components';
import { useTranslation } from 'react-i18next';
import { BlockSnacksPlanInner, Chevron, NavTabsListForSnacks, NavTabsWrapper, RewardListForSnacksDrinks, ShowMoreWrapper } from './styles';
import { useConfig, useWindowSize } from 'app/hooks';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import SnacksAsideComponent from '../SnacksAsideComponent';
import { generatePath } from 'react-router-dom';
import SnacksAsideComponentContainer from '../SnacksAsideComponent/SnacksAsideComponent.container';
import { RowButton } from '../styles';
import SnacksAsideMobileComponent from '../SnacksAsideMobileComponent';
import ConfigContext from 'app/context/config';
import { StepSnacksAside } from '../StepSnacksAndDrinks/styles';
import BoxMenu from '../BoxMenu';
const { NavTabsItem } = NavTabs;

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  movieCinemaId: PropTypes.string.isRequired,
};
const defaultProps = {

};
const SnacksDrinks = ({
  history,
  setConcessionRequest,
  setConcessionItemRequest,
  setConcessionComboRequest,
  movieCinemaId,
  setConcessionData
}) => {
  const [t, i18n] = useTranslation();
  const {
    api: { endpoint }
  } = useConfig();
  const { routes } = useContext(ConfigContext);
  const [isFullDescription, showMore] = useState(false);
  const { width } = useWindowSize();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [comboId, setComboId] = useState({ "cinemaId": "1003", "id": 1, "item": "", "itemId": '1001' });
  const [categoriesItemData, setCategoriesItemData] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const categoriesData = useSelector(state => state?.concessions?.concessions);
  const categoriesItem = useSelector(state => state?.concessions?.item);
  const categoriesComboData = useSelector(state => state?.concessions?.comboItem);
  const selectedItems = useSelector(state => state?.concessions?.concessionData);
  const location = useLocation();
  const [windowSize, setWindowSize] = useState();
  const cinemaId = location?.pathname?.split('/')[3]?.split('-')[0];



  const updateItemQuantity = (item) => (newQuantity) => {
    const session = item.isCombo ? 'comboSession' : 'normalSession';
    const updatedItems = {
      normalSession: { ...selectedItems.normalSession },
      comboSession: { ...selectedItems.comboSession }
    };
    if (item?.isCombo && newQuantity >= 1) {
      handleOpenModal(item?.id, item?.description, item?.id);
    }
    if (newQuantity === 0) {
      delete updatedItems[session][item.id];
    } else {
      updatedItems[session][item.id] = {
        ...item,
        quantity: newQuantity,
        imagePath: item.imagePath,
        description: item.description,
        priceInCents: item.priceInCents
      };
    }
    setConcessionData(updatedItems);
  };

  // this for combo-catergory
  useEffect(() => {
    if (categoriesComboData?.length > 0 && categoriesItem?.length > 0) {
      setCategoriesItemData([...categoriesItem, ...categoriesComboData,])
    } else if (categoriesItem?.length > 0) {
      setCategoriesItemData([...categoriesItem]);
    }
  }, [categoriesItem, categoriesComboData]);

  useEffect(() => {
    setWindowSize(window.innerWidth);
  }, [window]);



  window.addEventListener('resize', function () {
    setWindowSize(window.innerWidth);
  }, true);

  useEffect(() => {
    setConcessionRequest();
  }, []);


  const handleShowMore = () => {
    showMore(!isFullDescription);
  }

  useEffect(() => {
    if (categoriesData && categoriesData.length > 0) {
      setConcessionItemRequest(cinemaId, categoriesData[activeTab]?.id);
      setConcessionComboRequest(cinemaId, categoriesData[activeTab]?.id);
    }
  }, [categoriesData, activeTab]);

  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const handleRemoveItem = (itemName, session) => {
    const updatedItems = {
      normalSession: { ...selectedItems.normalSession },
      comboSession: { ...selectedItems.comboSession }
    };
    delete updatedItems[session][itemName];
    setConcessionData(updatedItems);
  };

  const handleOpenModal = (id, item, itemId) => {
    setComboId({ cinemaId, id, item, itemId });
    setIsModalOpen(!isModalOpen)
  };

  const visibleUserDetails = isFullDescription ? categoriesItemData : categoriesItemData?.slice(0, 4);

  const tabs = [
    { text: t('tabs.menus') },
    { text: t('tabs.drinks') },
    { text: t('tabs.snacks') },
    { text: t('tabs.sweets') }
  ];


  const renderTabContent = () => {
    const selectedCategory = categoriesData[activeTab];
    if (!selectedCategory) return null;

    return (
      <div>
        <BlockSnacksPlanInner>
          <NavTabsWrapper>
            <NavTabsListForSnacks>
              {/* Render tabs */}
              {tabs.map((tab, index) => (
                <NavTabsItem
                  key={index}
                  isSelected={index === activeTab}
                  onClick={() => handleTabChange(index)}
                  text={tab.text}
                />
              ))}
            </NavTabsListForSnacks>
          </NavTabsWrapper>
          <RewardListForSnacksDrinks>
            {visibleUserDetails?.map((item, index) => (
              <div style={{ position: 'relative', cursor: item?.isCombo ? 'pointer' : '' }}>
                {/* if not in stock then add this style in the below div,style={{ opacity: "70%" }} */}
                <div>
                  <div
                    key={item?.idx}
                    // className={item?.pointsCost < userDetails?.balance?.bonusPoints ? "reward-list__item " : "reward-list__item inactive "}
                    className={'reward-list__item'}
                  >
                    <div className="reward-list__item__content">
                      {width > 740 ? (
                        <>
                          <div className='reward-list__item__desktop'>
                            <Image className="rewardImage" src={`${endpoint}${item?.imagePath}`} />
                            <h4>{item?.description}</h4>
                            <h3>£ {(item?.priceInCents / 100).toFixed(2)}</h3>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="reward-list__item_mobile">
                            <Image className="rewardImage" src={`${endpoint}${item?.imagePath}`} />
                          </div>
                          <div className='reward-list__item_mobile_text'>
                            <h4>{item?.description}</h4>
                            <h3>£ {(item?.priceInCents / 100).toFixed(2)}</h3>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  <div className='snacks_inputField'>
                    <InputNumber
                      value={selectedItems[item?.isCombo ? 'comboSession' : 'normalSession'][item?.id]?.quantity || 0}
                      onChange={updateItemQuantity(item)}
                    // onClick={item?.isCombo ? () => handleOpenModal(item?.id, item?.description) : ""}
                    />
                  </div>
                </div>
                <div className='notInStock'>
                  <span>Not in Stock</span>
                </div>
              </div>
            ))}
          </RewardListForSnacksDrinks>
          {
            categoriesItemData?.length > 4 &&
            <ShowMoreWrapper>
              <Fragment>
                <button
                  sm
                  isDefault
                  className="b-movie-description__btn"
                  onClick={() => handleShowMore()}
                >
                  {isFullDescription ? t('common.show_less') : t('common.show_more')}
                  <Chevron className="_with-chevron" isRotated={isFullDescription} />
                </button>
              </Fragment>
            </ShowMoreWrapper>
          }
        </BlockSnacksPlanInner>
      </div>
    );
  };

  return (
    <>
      <div className="b-seatplan">
        {renderTabContent()}
      </div>
      {
        windowSize >= 992 ?
          <StepSnacksAside>
            <SnacksAsideComponentContainer movieCinemaId={movieCinemaId} selectedItems={selectedItems} handleRemoveItem={handleRemoveItem} />
          </StepSnacksAside>
          :
          <SnacksAsideMobileComponent selectedItems={selectedItems} handleRemoveItem={handleRemoveItem} movieCinemaId={movieCinemaId} />}
      {isModalOpen && <BoxMenu comboId={comboId} isModalOpen={isModalOpen} windowSizes={windowSize} setIsModalOpen={setIsModalOpen} />}
    </>
  )
}
export default SnacksDrinks;